<template>
  <div class="aboutTime">
    <div class="alltime">
      <div
        class="time"
        v-for="(item, index) in btnList"
        @click="btnClick(item)"
        :class="item.active?'active':''"
        :key="index"
      >{{item.name}}
      </div>
    </div>

    <div class="chooseTime" v-if="showChoose">
      <div class="timeabout" style="color:rgba(102,102,102,1)">时间范围：</div>
      <el-date-picker
        value-format="timestamp"
        v-model="value1"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
      ></el-date-picker>
      <el-button size="mini" @click="changeTime" class="timeSearch">查询</el-button>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      btnList: {
        type: Array,
        default: function () {
          return [
            {
              type: "1",
              name: "今日",
              active: true
            },
            {
              type: "2",
              name: "近一周",
              active: false
            },
            {
              type: "3",
              name: "近一月",
              active: false
            },
            {
              type: "4",
              name: "近一年",
              active: false
            },
            {
              type: "5",
              name: "累计",
              active: false
            }
          ];
        }
      },
      showChoose: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        value1: ""
      };
    },
    methods: {
      btnClick(row) {
        // console.log(row)
        this.btnList.map(_ => {
          _.active = false;
          if (_.type.includes(row.type)) {
            _.active = true;
          }
          return _;
        });
        this.value1 = null
        this.$emit("btnClick", row.type);
      },
      changeTime() {
        this.btnList.map(_ => {
          _.active = false;
        });
        this.$emit('changeTime', this.value1)
      }
    }
  };
</script>

<style lang='less' scoped>
  .aboutTime {
    display: flex;
    align-items: center;

    .alltime {
      display: flex;
      margin-right: 35px;
      height: 30px;

      .time {
        width: 70px;
        height: 30px;
        box-sizing: border-box;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        font-style: 12px;
        color: rgba(51, 51, 51, 1);
        border: 1px solid rgba(221, 221, 221, 1);
        margin: 0 0 -1px -1px;
      }
    }

    .chooseTime {
      display: flex;
      align-items: center;
      /*margin-right: 20px;*/

      .el-date-editor {
        border: 1px solid rgba(221, 221, 221, 1);
        border-right: 0;
        border-top-right-radius: 0;
      border-bottom-right-radius: 0;
        height: 29px;
        width: 229px;

        ::v-deep .el-range-separator {
          display: flex;
          align-items: center;
          margin-right: 5px;
        }

        ::v-deep .el-input__icon {
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }

    .active {
      background: rgba(89, 204, 225, 1);
      color: rgba(255, 255, 255, 1) !important;
    }

    .timeSearch {
      color: #fff !important;
      background-color: #59cce1 !important;
      border: 1px solid #59cce1;
      // border: none;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      height: 29px;
    }
  }
</style>
